import { atualizarMensagemService } from "../../../services/atualizarMensagemService";

export const useMessagemPessoa = () => {
  const atualizar = async (token: string, data: any) => {
    const atualizarMensagem = await atualizarMensagemService(token, data);
    if (atualizarMensagem) {
      return true;
    } else {
      return false;
    }
  };

  return { atualizar };
};
